const COORDINATE_MAP_ZOOM = 15;

function hasValidCoordinate(merchant) {
  const { lat, lng } = merchant;
  // unset coordinates come back as 0 rather than null
  return Boolean(Number(lat)) && Boolean(Number(lng));
}

/**
 * Resolves the iframe URL for the merchant's location map, preferring the
 * configured embed and falling back to one built from its coordinates.
 * @param {Object} merchant the active merchant (location_embed_map, lat, lng)
 * @returns {string} embed URL, or '' when neither source is available
 */
export function getMerchantMapEmbedUrl(merchant) {
  if (!merchant) return '';
  if (merchant.location_embed_map) return merchant.location_embed_map;
  if (!hasValidCoordinate(merchant)) return '';
  return `https://maps.google.com/maps?q=${merchant.lat},${merchant.lng}&z=${COORDINATE_MAP_ZOOM}&output=embed`;
}



// WEBPACK FOOTER //
// ./src/utils/merchantLocation.js